import { useState } from 'react';

import { useFormik } from 'formik';

import { useLanguage } from '../../../context/LanguageContext';
import { useGetLanguages } from '../../../services/redux/api/translationsAPI';
import {
  useGetMyDetails,
  useUpdateUser,
} from '../../../services/redux/api/usersApi';
import { FormMode } from '../../../shared/constants';

export function useUserConfigComponent() {
  const { data: user } = useGetMyDetails();
  const [updateUser, { isLoading }] = useUpdateUser();
  const [mode, setMode] = useState<FormMode>(FormMode.view);
  const { data: languages } = useGetLanguages();
  const { currentLanguage } = useLanguage();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      scope: user?.accessConfig?.scope,
      postsScope: user?.accessConfig?.postsScope,
      commentsScope: user?.accessConfig?.commentsScope,
      language: languages?.find(
        (l) => l.id === (user?.languageId || currentLanguage?.id),
      ),
    },
    onSubmit,
  });

  function onSubmit() {
    updateUser({
      id: user.id,
      body: {
        languageId: formik.values.language.id,
        accessConfig: {
          scope: formik.values.scope,
          postsScope: formik.values.postsScope,
          commentsScope: formik.values.commentsScope,
        },
      },
    }).then((response) => {
      if ('data' in response) {
        setMode(FormMode.view);
      }
    });
  }

  function onCancelChanges() {
    formik.resetForm({
      values: {
        language: languages?.find(
          (l) => l.id === user?.languageId || currentLanguage?.id,
        ),
        scope: user?.accessConfig?.scope,
        postsScope: user?.accessConfig?.postsScope,
        commentsScope: user?.accessConfig?.commentsScope,
      },
    });
    setMode(FormMode.view);
  }

  return { formik, isLoading, onCancelChanges, mode, setMode };
}
